import React from "react";
import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from "@shadcn-in-nx/ui/card";
import { Badge } from "@shadcn-in-nx/ui/badge";
import IntegrationSecuritySelect from "./IntegrationSecuritySelect";

export default function IntegrationCard({ item, onSecurityChange, entityFields }) {
    return (
        <Card className="overflow-hidden">
            <CardHeader className="flex flex-row items-start justify-between space-y-0 pb-2">
                <div className="space-y-1">
                    <CardTitle className="text-base font-medium">
                        {item.integration?.name || "Unknown Integration"}
                    </CardTitle>
                    <CardDescription className="text-xs">
                        {item.integration?.platform || "Custom Provider"}
                    </CardDescription>
                </div>
                {item.integration?.logo && (
                    <img
                        src={item.integration.logo}
                        alt={item.integration.name}
                        className="h-8 w-8 rounded object-contain"
                    />
                )}
            </CardHeader>
            <CardContent className="space-y-3">
                {item.integration?.isPublic && (
                    <Badge variant="outline" className="text-xs">
                        Public
                    </Badge>
                )}
                <IntegrationSecuritySelect
                    rule={item.securityRule}
                    onChange={(rule) => onSecurityChange(item.integrationId, rule)}
                    entityFields={entityFields}
                />
            </CardContent>
        </Card>
    );
}
